export class Coordinates {
    latitude: string | number;
    longitude: string | number;
    accuracy?: number;

    constructor(that?: Coordinates) {
        if (that) {
            this.latitude = +that.latitude;
            this.longitude = +that.longitude;
            this.accuracy = +that.accuracy;
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/models/coordinates.model.ts